import {serverCall} from "../../http";
import {CREAT_UPDATE_TEMPLATE, RECORD_FILTERS, UPDATE_RECORD_STATUS} from "@/app/admin/templates/page";
import {UPDATE_HTML_PROPS} from "@/app/admin/templates/[templateId]/page";

export const getAllTemplates = async (data: RECORD_FILTERS) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getAllTemplates",
        apiDir: `webapi/shared`,
    }, null)
}

export const createNewTemplate = async (data: CREAT_UPDATE_TEMPLATE) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/createNewTemplate",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateTemplate = async (data: CREAT_UPDATE_TEMPLATE) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateTemplate",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateHtmlContent = async (data: UPDATE_HTML_PROPS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateHtmlContent",
        apiDir: `webapi/shared`,
    }, null)
}

export const deleteTemplate = async (uid: number) => {
    return await serverCall({
        type: "delete",
        timeout: 1,
        data: {
            uid
        },
        endpoint: "/deleteTemplate",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateTemplateStatus = async (data: UPDATE_RECORD_STATUS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateTemplateStatus",
        apiDir: `webapi/shared`,
    }, null)
}

export const getTemplateById = async (uid: number) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            uid
        },
        endpoint: "/getTemplateById",
        apiDir: `webapi/shared`,
    }, null)
}